let bindingRowUidSeq = 0

/** 客户端唯一 id：拖拽列表 :key 与 Sortable 复用 DOM，禁止用 index。 */
export function createBindingRowUid() {
  bindingRowUidSeq += 1
  return `b-${Date.now().toString(36)}-${bindingRowUidSeq}`
}

export function ensureBindingRowUid(row) {
  if (!row || row.uid) {
    return row
  }
  return { ...row, uid: createBindingRowUid() }
}
